import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCategoryTabs } from "store/HomeSlice";
import ProductsWithSlide from "components/ProductsWithSlide";
import styles from "./style.module.css";

export default function CategoryTabsProducts() {
  const dispatch = useDispatch();
  const currentLanguage = useSelector(({ main }) => main.currentLanguage);
  const { categoryTabs } = useSelector(({ home }) => home);
  const [activeCategoryId, setActiveCategoryId] = useState(null);

  useEffect(() => {
    if (!categoryTabs?.categories?.length) {
      dispatch(getCategoryTabs());
    }
  }, [categoryTabs?.categories?.length, dispatch]);

  useEffect(() => {
    if (!activeCategoryId && categoryTabs?.categories?.length) {
      setActiveCategoryId(categoryTabs.categories[0].id);
    }
  }, [activeCategoryId, categoryTabs?.categories]);

  const title = useMemo(() => {
    if (!categoryTabs) return null;
    return (
      categoryTabs[`title_${currentLanguage}`] ||
      categoryTabs.title_hy ||
      categoryTabs.title_en ||
      null
    );
  }, [categoryTabs, currentLanguage]);

  const products = useMemo(() => {
    if (!activeCategoryId || !categoryTabs?.products_by_category) return [];
    return (
      categoryTabs.products_by_category[String(activeCategoryId)] ||
      categoryTabs.products_by_category[activeCategoryId] ||
      []
    );
  }, [activeCategoryId, categoryTabs?.products_by_category]);

  if (!categoryTabs?.categories?.length) {
    return null;
  }

  return (
    <div className={`wrapper ${styles.section}`}>
      {title ? <h3 className={styles.title}>{title}</h3> : null}
      <div className={styles.tabsWrap}>
        <div className={styles.tabs}>
          {categoryTabs.categories.map((category) => {
            const isActive = Number(activeCategoryId) === Number(category.id);
            const label =
              category[`name_${currentLanguage}`] ||
              category.name_hy ||
              category.name_en ||
              "";
            return (
              <button
                key={category.id}
                type="button"
                className={`${styles.tab} ${isActive ? styles.tabActive : ""}`}
                onClick={() => setActiveCategoryId(category.id)}
              >
                {label}
              </button>
            );
          })}
        </div>
      </div>
      {products?.length ? (
        <ProductsWithSlide
          productsData={products}
          noWrapper
          item_list_id={`category-tabs-${activeCategoryId}`}
          item_list_name={title || "Category tabs"}
        />
      ) : null}
    </div>
  );
}
